var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Translation component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTranslation extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.62891 1.85449C9.62891 1.44028 9.29312 1.10449 8.87891 1.10449C8.46469 1.10449 8.12891 1.44028 8.12891 1.85449V4.22559H4.19643C4.19628 4.22559 4.19612 4.22559 4.19597 4.22559H1.85547C1.44126 4.22559 1.10547 4.56137 1.10547 4.97559C1.10547 5.3898 1.44126 5.72559 1.85547 5.72559H3.85142L7.8895 10.4401L3.6271 15.4129C3.35754 15.7274 3.39396 16.2009 3.70845 16.4704C4.02295 16.74 4.49642 16.7036 4.76599 16.3891L8.87695 11.593L9.77636 12.643C10.0458 12.9576 10.5193 12.9942 10.8339 12.7248C11.1485 12.4553 11.185 11.9818 10.9156 11.6672L9.86481 10.4404L13.9061 5.72559H15.9024C16.3166 5.72559 16.6524 5.3898 16.6524 4.97559C16.6524 4.56137 16.3166 4.22559 15.9024 4.22559H13.5618H13.5613H9.62891V1.85449ZM8.87736 9.28759L11.9305 5.72559H8.90497C8.89632 5.72588 8.88763 5.72603 8.87891 5.72603C8.87018 5.72603 8.86149 5.72588 8.85284 5.72559H5.82643L8.87736 9.28759ZM14.557 16.2598L16.6826 11.2977L18.8082 16.2598H14.557ZM13.9144 17.7598L11.9093 22.4404C11.7462 22.8212 11.3053 22.9976 10.9246 22.8345C10.5438 22.6714 10.3674 22.2305 10.5305 21.8498L15.4301 10.4121C15.5335 10.1663 15.707 9.95625 15.9289 9.80827C16.1521 9.65948 16.4144 9.58008 16.6826 9.58008C16.9509 9.58008 17.2131 9.65948 17.4363 9.80827C17.6582 9.95624 17.8317 10.1662 17.9351 10.4121L22.8347 21.8498C22.9978 22.2305 22.8214 22.6714 22.4406 22.8345C22.0599 22.9976 21.619 22.8212 21.4559 22.4404L19.4508 17.7598H13.9144Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTranslation.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTranslation.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTranslation.prototype, "size", void 0);
if (customElements.get('cat-icon-translation') === undefined) {
    customElements.define('cat-icon-translation', BlocksIconTranslation);
}
